const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/intelligence/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
type ContentIntelligenceBeforeLoadArgs = {
  context: PermissionContext & {
    flags: {
      tempoContentIntelligenceEnabled: boolean;
    };
  };
  params: {
    loopId: number;
    org: string;
  };
};
export const contentIntelligenceBeforeLoad = async (args: ContentIntelligenceBeforeLoadArgs) => {
  await requirePermission('view_loop')(args);
  if (!args.context.flags.tempoContentIntelligenceEnabled) {
    throw redirect({
      to: '/org/$org/loop/$loopId/strategy',
      params: args.params,
      replace: true
    });
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/intelligence/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: contentIntelligenceBeforeLoad,
  validateSearch: zodValidator(itemPanelSearchSchema),
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.contentIntelligence.title)
    }
  }
});